import React, {Fragment,useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { Features } from '../Features';
import {NoticeTicker} from './NoticeTicker';


export function LandingPage() {
  
  const sliderTexts = [
    {"query":"Time to select Engineering Colleges?"},
    {"query": "Find everything you need in one place"},
    {"query":"Seat Availability"},
    {"query":"Cutoff Scores"},
    {"query":"NIRF Rankings"},
    {"query":"Exam Notices & Schedules"},
    {"query":"Cap Round Notices & Schedules"},
    {"query":"All you need - in one place"},
    {"query":"Turn your academic aspirations into reality","message":"Make Informed Choices"},
  ]
  
  function ChatBubbleCarousel() {
    return (
      <div className="h-64 w-full flex items-center justify-center">
            <Swiper
              modules={[Autoplay]} spaceBetween={20} slidesPerView={1} loop autoplay={{ delay: 3000 }} className="w-full bg-light-green-500/5 rounded-full">
              {sliderTexts.map((sample, index) => (
                <SwiperSlide key={index}>
                  <div className="h-64 flex items-center justify-center">
                    <p className="text-white text-center text-2xl font-semibold">
                      {sample.query}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
        </div>
    );
  }

  return (
    <Fragment>
          <div className="max-w-full m-4">
            <div className="w-full h-[300px] bg-no-repeat aspect-[21/9] bg-cover bg-center top-0 left-0 bg-mobile md:bg-landscape">
                <div className="hidden md:block backdrop-blur-sm bg-opacity-60 top-0 left-0 bottom-0 w-72 h-64 rounded-full bg-light-green-500 px-4 py-3 transition-all duration-500 ease-in-out">
                      <ChatBubbleCarousel/>
                </div>
            </div>
            <div className="relative m-2 bottom-0 w-full z-10 drawer-content">
              <NoticeTicker/>
              <Features/>
              <div className="container mx-auto mt-16 border-t pt-8 text-center text-sm md:text-base text-gray-600">
              Spotted a bug? Got an idea? Want to tell us we're awesome? <span>
              <a href="/contactus" className="text-blue-600 hover:underline font-medium">Send us a message.</a></span> 
              </div>
            </div>
          </div>
    </Fragment>
  );
}

